import type { AtlasMission } from '../atlas.types';

export const analyticsMission: AtlasMission = {
  id: 'load-analytics-data',
  title: 'Load your analytics data',
  description:
    'Connect Jira, run a Full Update, explore filters and tabs, then set up your team calendar.',
  kicker: 'Guided tour',
  estimatedMinutes: 5,
  entryRoute: '/analytics',
  featureKey: 'atlas.loadAnalyticsData',
  storage: 'atlas',
  steps: [
    {
      id: 'connect',
      title: 'Connect Jira first',
      body: 'Open Settings in the header, then the Project Settings tab, and set the organization Jira account and this product’s project key.',
      anchorId: 'profile-project-jira-anchor',
      primaryLabel: 'Next →',
    },
    {
      id: 'full-update',
      title: 'Run a Full Update',
      body: 'Full Update pulls worklogs, issues, and estimates from Jira. It can take a few minutes the first time. Incremental Update only refreshes recently changed issues.',
      anchorId: 'analytics-database-anchor',
      primaryLabel: 'Next →',
    },
    {
      id: 'date-filter',
      title: 'Focus with the date filter',
      body: 'Every chart on Analytics responds to the date filter. Try a quick preset like This Week or This Month to see how the numbers change.',
      anchorId: 'analytics-date-filter-anchor',
      primaryLabel: 'Next →',
    },
    {
      id: 'details-tab',
      title: 'Explore the Details tab',
      body: 'Details breaks time down by person, task, and status. This is where one-on-one reviews usually start.',
      anchorId: 'analytics-tab-details-anchor',
      primaryLabel: 'Next →',
    },
    {
      id: 'estimation-tab',
      title: 'Check estimation accuracy',
      body: 'Estimation compares estimated vs logged time by release, quarter, and person. It is the feedback loop that makes future estimates better.',
      anchorId: 'analytics-tab-estimation-anchor',
      primaryLabel: 'Next →',
    },
    {
      id: 'calendar-setup',
      title: "Set up your team's calendar",
      body: 'The Calendar shows availability, absences, and bank holidays — great for planning. Use Open Calendar or the Calendar link in the header.',
      anchorId: 'nav-calendar-anchor',
      primaryLabel: 'Open Calendar',
    },
  ],
};
